import { useState, useEffect, useCallback } from 'react';
import type { EventData } from 'react-joyride';

interface UseTourReturn {
  runTour: boolean;
  tourKey: number;
  startTour: () => void;
  handleCallback: (data: EventData) => void;
}

export function useTour(storageKey: string, delay = 600): UseTourReturn {
  const [runTour, setRunTour] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  // Auto-start on first visit
  useEffect(() => {
    if (!localStorage.getItem(storageKey)) {
      const timer = setTimeout(() => setRunTour(true), delay);
      return () => clearTimeout(timer);
    }
  }, [storageKey, delay]);

  const startTour = useCallback(() => {
    setTourKey(k => k + 1);
    setRunTour(true);
  }, []);

  const handleCallback = useCallback((data: EventData) => {
    if (data.type === 'tour:end' || data.action === 'skip' || data.action === 'close') {
      setRunTour(false);
      localStorage.setItem(storageKey, 'true');
    }
  }, [storageKey]);

  return { runTour, tourKey, startTour, handleCallback };
}
